export const isEven = (num: number) => !(num % 2)
